import styled from "styled-components";
import { FC } from "react";

import {
  getIconSizeValue,
  Icon,
  IconName,
  IconSize,
  IconVariant,
} from "../../Icon";

export type IconVariantArgs = {
  isSelected?: boolean;
  isReadOnly?: boolean;
  isDisabled?: boolean;
  isFocused?: boolean;
  menuIsOpen?: boolean;
};

const getIconVariant = ({
  isDisabled,
  isFocused,
  isReadOnly,
  isSelected,
  menuIsOpen,
}: IconVariantArgs): IconVariant => {
  if (isSelected || isFocused || menuIsOpen) {
    return "ACTIVE";
  }
  if (isDisabled || isReadOnly) {
    return "DISABLED";
  }
  return "DEFAULT";
};

type StyledLabelWithIconProps = {
  $hasAnyIcons: boolean;
  $allowIcons: boolean;
  $iconSize: number;
};

const StyledLabelWithIcon = styled.div<StyledLabelWithIconProps>`
  display: grid;
  gap: 4px;
  grid-template-columns: ${({ $hasAnyIcons, $allowIcons, $iconSize }) =>
    $hasAnyIcons && $allowIcons ? `${$iconSize}px 1fr` : "1fr"};
  align-items: ${({ $iconSize }): string =>
    $iconSize < 16 ? "baseline" : "center"};
  *:last-child {
    grid-column-start: ${({ $hasAnyIcons, $allowIcons }) =>
      $hasAnyIcons && $allowIcons ? 2 : 1};
  }
`;

type LabelWithIconProps = {
  hasAnyIcons: boolean;
  allowIcons: boolean;
  iconName?: IconName;
  iconSize?: IconSize;
  IconVariantArgs?: IconVariantArgs;
  children?: React.ReactNode;
};

export const LabelWithIcon: FC<LabelWithIconProps> = ({
  iconName,
  iconSize = "small",
  allowIcons,
  hasAnyIcons,
  IconVariantArgs,
  children,
}) => (
  <StyledLabelWithIcon
    $hasAnyIcons={hasAnyIcons}
    $allowIcons={allowIcons}
    $iconSize={getIconSizeValue(iconSize)}
  >
    {allowIcons && iconName && (
      <Icon
        iconName={iconName}
        iconSize={iconSize}
        variant={getIconVariant(IconVariantArgs || {})}
        plain
      />
    )}
    <div>{children}</div>
  </StyledLabelWithIcon>
);
